<template>
  <div>
    <div v-for="field in fields" :key="field.id" class="sd-input">
      <input
        v-if="field.name === 'email'"
        v-model="form.email"
        :placeholder="
          field.required
            ? `* ${field.placeholder || field.displayName || field.name}`
            : `${field.placeholder || field.displayName || field.name}`
        "
        :class="[{ warn: errors.email }]"
        :disabled="hasEmail"
        @focus="errors.email = false"
      />
      <textarea
        v-else-if="field.name === 'description'"
        v-model="form.description"
        :placeholder="
          field.required
            ? `* ${field.placeholder || field.displayName || field.name}`
            : `${field.placeholder || field.displayName || field.name}`
        "
        :class="[{ warn: errors.description }]"
        rows="7"
        :maxlength="MAX_DESCRIPTION_CHAR_NUM"
        @focus="errors.description = false"
      />
      <p v-if="field.name === 'description'" class="textarea-char" :class="{ exceed: isDescriptionExceed }">
        {{ descriptionLength }} / {{ MAX_DESCRIPTION_CHAR_NUM }}
      </p>
      <p v-if="!!errors[field.name] && field.name !== 'description'" :key="`${field.id}err`" class="warn-note-wrapper">
        <span class="star">*</span>
        Please enter a valid {{ field.displayName.toLowerCase() }}
      </p>
      <p v-if="!!errors[field.name] && field.name === 'description'" class="warn-note-wrapper">
        <span class="star">*</span>
        <span>
          {{
            isDescriptionExceed
              ? Locale.i18n.t('page.guest.description.exceed', {
                  maxChar: MAX_DESCRIPTION_CHAR_NUM,
                })
              : Locale.i18n.t('page.guest.description.invalid')
          }}
        </span>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Model, Prop, PropSync, Vue } from 'vue-property-decorator';
import { FormField } from '@/common/types';
import { MAX_DESCRIPTION_CHAR_NUM } from '@/common/config';
import { TicketForm } from './LoggedInForm.utils';
import * as Locale from '@/plugins/i18n';

@Component({})
export default class LoggedInFormContent extends Vue {
  @Model('input') readonly form!: TicketForm;
  @PropSync('errors', {
    default: () => ({
      description: false,
      subject: false,
    }),
  })
  readonly inputErrors!: {
    description: boolean;
    subject: boolean;
  };

  @Prop({ default: () => [] }) readonly fields!: FormField[];
  @Prop(Boolean) hasEmail!: boolean;

  readonly Locale = Locale;

  MAX_DESCRIPTION_CHAR_NUM = MAX_DESCRIPTION_CHAR_NUM;

  get descriptionLength() {
    return this.form.description?.length || 0;
  }

  get isDescriptionExceed() {
    return this.descriptionLength > MAX_DESCRIPTION_CHAR_NUM;
  }
}
</script>
